export const getListGifts = (state: any) => state.gifts.giftsList;
export const findGiftByID = (state: any, id: string) => {
    const listGifts = getListGifts(state);
    return listGifts.find((gift: any) => gift._id === id);
};
export const getPagination = (state: any) => state.gifts.pagination;
export const getSearch = (state: any) => state.gifts.search;
